import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';

import { Observable, Subscription, TeardownLogic } from 'rxjs';

import { ApplicantInfo } from 'services/applicant/applicant.service.class';
import { UserInfo } from 'services/user/user.service.class';

@Component({
    selector: 'app-user-header',
    styleUrls: ['user-header.component.scss'],
    templateUrl: 'user-header.component.html',
})
export class UserHeaderComponent implements OnInit, OnDestroy {
    private _subrelease = new Subscription();
    set subrelease(sub: TeardownLogic) {
        this._subrelease.add(sub);
    }

    @Input() Application: ApplicantInfo | null = null;
    @Input() User: UserInfo | null = null;

    @Output() logout = new EventEmitter<void>();

    constructor() {}

    ngOnDestroy(): void {
        this._subrelease.unsubscribe();
    }

    ngOnInit(): void {}

    // #region Logout

    Logout() {
        this.logout.emit();
    }

    // #endregion
}
